export const pageTitleMap = {
  "/": "Manage Tags",
  "/remixer-tags": "Manage Tags",
  "/manage-artist": "Manage Artist",
  "/remixer-artists": "Manage Artist",
  "/manage-remixers": "Manage Remixers",
  "/manage-track": "Manage Track",
  "/remixer-manage-track": "Manage Track",
  "/add-tracks": "Add New Tracks",
  "/remixer-add-tracks": "Add New Tracks",
  "/add-tracks/:id": "Edit Track",
  "/remixer-add-tracks/:id": "Edit Track",
  "/manage-playlist": "Manage Playlist",
  "/manage-playlist-subcategoryManager": "Add Subcategory",
  "/manage-playlist-add-new-playlist": "Add New Playlist",
  "/remixer-overview": "Remixer Overview",
  "/remixer-user/view/:id": "Remixer Overview",
  "/remixer-user/edit/:id": "Edit Remixer Profile",
  "/profile": "Remixer Profile",
  "/remixer-user/add": "Add new Remixer profile",
  "/manage-customer": "Customer Overview",
  "/pending-requests": "Pending Customer Requests",
  "/onetime-coupon-codes": "One Time Coupons",
  "/unlimited-coupon-codes": "Unlimited Coupons",
  "/onetime-amount-coupon-codes": "One Time Amount Coupons",
  "/unlimited-amount-coupon-codes": "Unlimited Amount Coupons",
  "/top-edits": "Top 10 Edits",
  "/edit-playlist/:id": "Edit Playlist",
  "/customer/:id": "Sign-Up Applications",
  "/banner-management": "Banner Management",
  "/chart-management": "Chart Management",
  "/user-monitoring": "User Monitoring & Login Activity Management",
  "/add-producer-pack": "Add Producer Pack",
  "/edit-producer-pack/:id": "Update Producer Pack",
  "/download-tracking": "Download Tracking",
};
